import React from "react";
import { Title } from "../components/AllExportedComponent";
import { GoMarkGithub } from "react-icons/go";
import { FaCode, FaStar, FaRegCalendarAlt, FaCodeBranch, FaSearch } from "react-icons/fa";
import moment from "moment";


function Repo() {

    const [repos, setRepos] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [query, setQuery] = React.useState('');

    React.useEffect(function () {
        async function getData(){
            const request = await fetch(
                'https://api.github.com/users/bagussona/repos?sort=updated'
            );
            
            const response = await request.json();
            setRepos(response);
            setLoading(false);

        }
        getData();
    }, []);

    const filteredArray = repos.filter( obj => obj.name.toLowerCase().indexOf(query.toLowerCase()) > -1 );

    return <>
        <div className="w-full">
            <div className="w-full flex flex-col mt-12 mb-10">
                <Title title="Repo" subtitle="Saya" />
                <div className="relative flex justify-center w-full flex-wrap mt-8">
                    <div className="flex">
                        <span className="z-10 h-full font-normal absolute text-center bg-transparent rounded text-gray-600 items-center justify-center w-8 pl-3 py-3">
                            <FaSearch />
                        </span>
                        <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="cari apa?" name="search" id="search" className="px-3 py-3 relative bg-white rounded-full text-gray-600 text-sm shadow focus:outline-none focus:ring w-80 sm:w-96 md:w-[28rem] lg:w-[32rem] xl:w-[36rem] 2xl:w-[40rem] pl-10"/>
                    </div>
                </div>
            </div>
            {loading ? <div className="w-full flex justify-center items-center">fetching data ...</div> :
                <div className="w-100 flex justify-center items-center">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4">

                    {filteredArray.map(function(repo){
                        return <div className="card transition ease-in-out hover:-translate-y-1 hover:scale-100 duration-300 w-[19rem] sm:w-[26rem] md:w-[19rem] xl:w-[22rem] 2xl:w-[26rem] bg-white mx-2 my-2" key={repo.id}>
                            <div className="flex flex-col p-4">
                                <div className="flex flex-col mb-6 pb-6 border-b border-slate-200">
                                    <a href={repo.svn_url}>
                                        <h1 className="truncate text-2xl font-bold text-slate-900"><strong>{repo.name}</strong></h1>
                                    </a>
                                    <div className="flex flex-row justify-between items-center py-2 rounded-md space-x-4 text-xs font-light text-slate-600">
                                        <div className="flex flex-row">
                                            <span className="mx-1"><FaCodeBranch/></span>
                                            <span className="mx-1">{repo.default_branch}</span>
                                        </div>
                                        <div className="flex flex-row">
                                            <span className="mx-1"><FaRegCalendarAlt/></span>
                                            <span className="mx-1">{moment(repo.created_at).format("MMM YYYY")}</span>
                                        </div>
                                    </div>
                                    <p className="truncate flex items-center text-xs text-slate-600 mt-2 w-[17rem] sm:w-[24rem] md:w-[17rem] xl:w-[20rem] 2xl:w-[24rem] h-6 text-justify">{repo.description}</p>
                                </div>
                                <div className="flex flex-row justify-between items-center space-x-4 text-xs font-medium">
                                    <a href={repo.svn_url}>
                                        <button className="flex flex-row items-center justify-center py-2 px-4 rounded-md bg-slate-800 text-white" type="button">
                                            <span className="mx-1">Lihat</span>
                                            <span className="mx-1"><GoMarkGithub/></span>
                                        </button>
                                    </a>
                                    <div className="flex flex-row justify-between py-2 px-2 rounded-md text-slate-800">
                                        <div className="flex flex-row justify-center items-center">
                                            <span className="mx-1"><FaStar/></span>
                                            <span className="mx-1">{repo.stargazers_count}</span>
                                        </div>
                                        <div className="flex flex-row justify-center items-center">
                                            <span className="mx-1"><FaCode/></span>
                                            <span className="mx-1">{repo.language}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    })}

                    </div>
                </div>
            }
        </div>
   </>
}

export default Repo;